export default __webpack_public_path__ + "static/media/28.67d04f58.jpg";